// @flow

import { combineReducers } from 'redux';
import type { CombinedReducer } from 'redux';
import { websocketReducer } from './websocketReducer';
import { userRegistrationReducer } from './userRegistrationReducer';
import { contentReducer } from './contentReducer';
import { i18nReducer } from './i18nReducer';
import { commonReducer } from './commonReducer';
import { depositReducer } from './depositReducer';
import { franceConnect } from './franceConnect';
import { sessionReducer } from './sessionReducer';
import { landingReducer } from './landingReducer';
import { tagManagerReducer } from './tagManagerReducer';
import type { RootActions } from '../types';

const combinedReducers = {
  websocket: websocketReducer,
  content: contentReducer,
  i18n: i18nReducer,
  common: commonReducer,
  userRegistration: userRegistrationReducer,
  deposit: depositReducer,
  franceConnect,
  session: sessionReducer,
  landing: landingReducer,
  tagManager: tagManagerReducer,
};

export const reducers: CombinedReducer<typeof combinedReducers, RootActions> = combineReducers(
  combinedReducers
);
